import { ButtonGroup, Td, Tr } from "@chakra-ui/react"
import { Container, Form, Heading, IconButton, Searchable, Section, Table, Tag } from "components"
import { Enums, Mask } from "config"
import { useWithdraws } from "hooks"
import moment from "moment"
import { useEffect, useState } from "react"
import { Withdraw } from "screens"

export default function Withdraws(){

    const [ page, setPage ] = useState(1)
    const [ status, setStatus ] = useState(null)
    const [ term, setTerm ] = useState('')
    const withdraws = useWithdraws(page, term, status)

    const [ withdraw, setWithdraw ] = useState(false)

    useEffect(() => { setPage(1) }, [term, status])

    return(
    <>
    <Container maxW="90%" mt={10}>

        <Heading title="Pedidos de saque">
            <ButtonGroup size="xs" isDisabled={withdraws.isFetching}>
                <IconButton label="Atualizar" icon="refresh" isLoading={withdraws.isFetching} onClick={withdraws.refetch} />
            </ButtonGroup>
        </Heading>

        <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por ID, Nome do consultor ou Código do saque...">
            <Form.Select onChange={e => setStatus(e.target.value)} options={[{ label: 'Todos os status', value: '' }, { label: 'Aprovado', value: Enums.WithdrawStatus.APPROVED },{ label: 'Cancelado', value: Enums.WithdrawStatus.CANCELED }, { label: 'Em Análise', value: Enums.WithdrawStatus.ANALYZING }, { label: 'Concluído', value: Enums.WithdrawStatus.DONE }, { label: 'Rejeitado', value: Enums.WithdrawStatus.REJECTED }]} />
        </Searchable>

        <Table columns={[{ children: '', isNumeric: true }, { children: 'Consultor' }, {children: 'Situação' }, { children: 'Valor', isNumeric: true }, { children: 'Status' }, { children: 'Enviado', isNumeric: true }, { children: 'Solicitação', isNumeric: true }, { children: '', isNumeric: true }]} setPage={setPage} meta={withdraws.data?.meta} loading={withdraws.isLoading}>
            { withdraws.data?.data?.map(item => (
                <Tr key={item.id} cursor="pointer" _hover={{ backgroundColor: 'rgba(0,0,0,0.05)' }} onClick={() => setWithdraw(item)}>
                    <Td isNumeric>{item.cod}</Td>
                    <Td>{item.consultant.customer.name}</Td>
                    <Td><Tag size="sm" colorScheme={Enums.ActiveMonthStatus.data(item?.consultant?.active_month_status).colorScheme} children={ item?.consultant?.active_month_status_label } /></Td>
                    <Td isNumeric fontWeight="bold">R$ {Mask.price(item.value)}</Td>
                    <Td><Tag size="sm" colorScheme={Enums.WithdrawStatus.data(item.status).colorScheme} children={item.status_label} /></Td>
                    <Td isNumeric fontSize="xs">{item.sent_at ? moment(item.sent_at).calendar() : <>&mdash;</>}</Td>
                    <Td isNumeric fontSize="xs">{moment(item.created_at).subtract(3, 'hours').format('DD/MM/YYYY HH:mm')}</Td>
                    <Td isNumeric>
                        {[Enums.WithdrawStatus.ANALYZING].includes(item.status) && <ButtonGroup size="xs"><IconButton icon="check" colorScheme="green" label="Aprovar" /><IconButton icon="cancel" colorScheme="red" label="Rejeitar" /></ButtonGroup>}
                    </Td>
                </Tr>
            ))}
        </Table>

    </Container>

    {/* Screens */}
    <Withdraw.View isOpen={!!withdraw} onClose={() => setWithdraw(false)} data={withdraw} />
    </>
    )
}
